import { Alert, Box, Stack, Typography } from '@mui/material';

/**
 * 수료 조건 체크박스 라벨. 필수 안내가 있으면 아래에 표시한다.
 */
export const CompletionRequirementOptionLabel = ({ option }) => {
  if (!option.helper) return option.label;

  return (
    <Box>
      <Typography variant="body2" component="span">
        {option.label}
      </Typography>
      <Typography variant="caption" color="text.secondary" display="block">
        {option.helper}
      </Typography>
    </Box>
  );
};

/**
 * 그룹 수료 조건·과정 선택 오류/경고를 표시한다.
 */
const GroupRequirementAlerts = ({ issues, sx }) => {
  if (!issues?.errors?.length && !issues?.warnings?.length) return null;

  return (
    <Stack spacing={1} sx={sx}>
      {issues.errors.map((message) => (
        <Alert key={message} severity="error">
          {message}
        </Alert>
      ))}
      {issues.warnings.map((message) => (
        <Alert key={message} severity="warning">
          {message}
        </Alert>
      ))}
    </Stack>
  );
};

export default GroupRequirementAlerts;
